import { KYMW1105Model } from './../kymw1105.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 取引先情報取得クラス
 *
 * @export GetGoodsSpecificationInfoService
 * @class GetGoodsSpecificationInfoService
 * @extends {PlessResponder}
 */
@Injectable()
export class GetGoodsSpecificationInfoService extends PlessJsonResponderSub<any> {
  // 処理に使用するModel
  private model: KYMW1105Model;
  private vo: any;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetGoodsSpecificationInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        PCode: this.vo.pCode,
        ItemCode: this.vo.itemCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetGoodsSpecificationInfoService
   */
  execute(model: KYMW1105Model, vo: any, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getGoodsSpecificationInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetGoodsSpecificationInfoService
   */
  success(data: any): void {
    this.model.setGoodsSpecifcationInfo(data);
    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }
}
